import { Controller } from "@hotwired/stimulus";

// Copies a string to the clipboard. Pass the text via a Stimulus param, e.g.
//   data-action="clipboard#copy" data-clipboard-text-param="https://…"
export class ClipboardController extends Controller {
  copy(event) {
    const text = event.params.text;
    if (text && navigator.clipboard) {
      navigator.clipboard.writeText(text);
    }
  }
}
